import React, { useState } from "react";
import { FaQuestion, FaChevronDown, FaRegQuestionCircle } from "react-icons/fa";
import Loader from "../../../components/Loader/Loader";
import { useStudentFaq } from "./hooks/useStudentFaq";
import { sanitizeHtml } from "../../../utils/sanitizeHtml";
import "./StudentFaq.css";

// Confirmed against the real backend (2026-10-22): the question/answer
// fields are `title`/`description`, and description is HTML (e.g.
// "<ol><li>...</li></ol>"), authored by school staff via the admin FAQ
// editor — not user-generated — so it's rendered as HTML, not escaped text.
const getQuestion = (faq) => faq?.title || faq?.question || faq?.name || "Untitled question";
const getAnswer = (faq) => faq?.description || faq?.answer || faq?.content || "";

const StudentFaq = () => {
  const { faqs, isLoading } = useStudentFaq();
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (index) => {
    setOpenIndex((current) => (current === index ? -1 : index));
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="sp-faq-page">
      <h2 className="sp-section-title">Frequently Asked Questions</h2>

      {faqs.length === 0 ? (
        <div className="sp-card sp-empty-state">
          <FaRegQuestionCircle size={28} />
          <p className="mb-0">No FAQs have been published yet.</p>
        </div>
      ) : (
        <div className="sp-faq-list">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div className={`sp-faq-item${isOpen ? " is-open" : ""}`} key={faq.id ?? index}>
                <button
                  type="button"
                  className="sp-faq-question"
                  onClick={() => toggle(index)}
                  aria-expanded={isOpen}
                >
                  <span className="sp-faq-question-main">
                    <span className="sp-icon-tile sp-faq-icon" data-tone="primary" aria-hidden="true">
                      <FaQuestion />
                    </span>
                    <span>{getQuestion(faq)}</span>
                  </span>
                  <span className="sp-faq-caret" aria-hidden="true">
                    <FaChevronDown />
                  </span>
                </button>
                {isOpen && (
                  // eslint-disable-next-line react/no-danger -- sanitized via DOMPurify in sanitizeHtml() above
                  <div className="sp-faq-answer" dangerouslySetInnerHTML={{ __html: sanitizeHtml(getAnswer(faq)) }} />
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default StudentFaq;
